import component from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-confirmation/lni-child-labor-complaint-confirmation.component.vue';
import module from '@gov.wa.lni/application.child-labor-complaint/source/components/lni-child-labor-complaint-confirmation/lni-child-labor-complaint-confirmation.module.js';

export default {
    component,
    module,
};